import {
  CreateResourceDetailsRequestDto,
  MetadataCreateInputMap,
  MetadataDtoMap,
  MetadataUpdateInputMap,
  NeedAddActionRequestDto,
  NeedCreationRequestDto,
  NeedDto,
  NeedPatchRequestDto,
  NeedsActionDto,
  NeedsMetadataDto,
  NeedsResourceDetailsDto,
  NeedViewDto,
  UpdateResourceDetailsRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const needRequests = {
  getNeedsForMember: EndpointDefinition.get<NeedViewDto, { memberId: string }>({
    name: 'getNeedsForMember',
    route: '/needs',
  }),

  patchNeed: EndpointDefinition.patch<
    NeedDto,
    NeedPatchRequestDto,
    { needId: number }
  >({
    name: 'patchNeed',
    route: '/needs/:needId',
  }),

  createNeed: EndpointDefinition.post<NeedDto, NeedCreationRequestDto, null>({
    name: 'createNeed',
    route: '/needs',
  }),

  addActionToNeed: EndpointDefinition.post<
    NeedsActionDto,
    NeedAddActionRequestDto,
    { needId: number }
  >({
    name: 'addActionToNeed',
    route: '/needs/:needId/action',
  }),

  createResourceReferral: EndpointDefinition.post<
    NeedsResourceDetailsDto,
    CreateResourceDetailsRequestDto,
    { actionId: number }
  >({
    name: 'createResourceReferral',
    route: '/needs/:actionId/referral',
  }),

  updateResourceReferral: EndpointDefinition.post<
    NeedsResourceDetailsDto,
    UpdateResourceDetailsRequestDto,
    { actionId: number }
  >({
    name: 'updateResourceReferral',
    route: '/needs/:actionId/referral',
  }),

  deleteNeed: EndpointDefinition.delete<NeedDto, { needId: number }>({
    name: 'deleteNeed',
    route: '/needs/:needId',
  }),

  getNeedsMetadata: EndpointDefinition.get<NeedsMetadataDto, null>({
    name: 'getNeedsMetadata',
    route: '/needs/metadata',
  }),

  createNeedsMetadata: EndpointDefinition.post<
    MetadataDtoMap[keyof MetadataDtoMap],
    MetadataCreateInputMap[keyof MetadataCreateInputMap],
    { type: keyof MetadataCreateInputMap }
  >({
    name: 'createNeedsMetadata',
    route: '/needs/metadata/:type',
  }),

  updateNeedsMetadata: EndpointDefinition.patch<
    MetadataDtoMap[keyof MetadataDtoMap],
    MetadataUpdateInputMap[keyof MetadataUpdateInputMap],
    { type: keyof MetadataDtoMap; id: number }
  >({
    name: 'updateNeedsMetadata',
    route: '/needs/metadata/:type/:id',
  }),
  getExpiringAndNeedsActionUserNeedsByGuide: EndpointDefinition.get<
    NeedDto[],
    { guideId: string }
  >({
    name: 'getExpiringAndNeedsActionUserNeedsByGuide',
    route: '/needs/expiring-and-needs-action-user-needs-by-guide/:guideId',
  }),
};
